import React from "react";
import Icon, { Rating } from "./Icon";
import ProductImage from "./ProductImage";
import { displayName, money } from "../utils";
import "./ProductCard.css";

const ProductCard = ({ product, qty, busy, onAdd, onChangeQty }) => {
  const name = displayName(product.name);
  return (
    <article className="product-card card">
      <ProductImage product={product} className="product-card-image" />
      <div className="product-card-body">
        <span className="product-card-category">{product.category}</span>
        <h3 className="product-card-name">{name}</h3>
        <Rating value={product.rating} />
        <div className="product-card-foot">
          <span className="product-card-price">{money(product.cost)}</span>
          {qty > 0 ? (
            <div className="stepper stepper-brand" role="group" aria-label={`${name} quantity`}>
              <button type="button" aria-label={`Remove one ${name}`} disabled={busy} onClick={() => onChangeQty(qty - 1)}>
                −
              </button>
              <output aria-live="polite">{qty}</output>
              <button type="button" aria-label={`Add one more ${name}`} disabled={busy} onClick={() => onChangeQty(qty + 1)}>
                +
              </button>
            </div>
          ) : (
            <button type="button" className="btn btn-primary" disabled={busy} onClick={onAdd}>
              <Icon name="plus" size={16} strokeWidth={2.4} />
              Add<span className="sr-only"> {name} to cart</span>
            </button>
          )}
        </div>
      </div>
    </article>
  );
};

export const ProductCardSkeleton = () => (
  <div className="product-card card" aria-hidden="true">
    <span className="product-image product-card-image skeleton" style={{ borderRadius: 0 }} />
    <div className="product-card-body">
      <span className="skeleton" style={{ height: 12, width: "40%" }} />
      <span className="skeleton" style={{ height: 18, width: "85%" }} />
      <span className="skeleton" style={{ height: 14, width: "50%" }} />
    </div>
  </div>
);

export default ProductCard;
